import {info_Green} from 'assets/images/images';
import React from 'react';

export const Address = () => (
  <>
    <header className="flex flex-col items-center mt-8">
      <div className="flex items-center gap-2 py-1 px-2 bg-[#E2F5F6] rounded-full">
        <img src={info_Green} alt="" width={20} height={20} className="" />
        <p className="text-sm rounded-lg text-[#4A878D] font-medium  ">
          Kindly enter your actual house address{' '}
        </p>
      </div>
    </header>
    <form className="w-full max-w-sm px-6">
      <label
        htmlFor="state"
        className="mt-4 mb-1 block text-[#1B2A4E] text-sm font-normal"
      >
        State
        <select
          id="state"
          className="mt-2 bg-[#F9F9F9] text-[#8D8D91] text-sm  rounded"
        >
          <option value="" disabled>
            Select State
          </option>
        </select>
      </label>
      <label
        htmlFor="LGA"
        className="mt-4 mb-1 block text-[#1B2A4E] text-sm font-normal"
      >
        Local Government Area
        <select
          id="LGA"
          className="mt-2 bg-[#F9F9F9] text-[#8D8D91] text-sm  rounded"
        >
          <option value="" disabled>
            Select LGA
          </option>
        </select>
      </label>
      <label
        htmlFor="street"
        className="mt-4 mb-1 text-[#1B2A4E] text-sm font-normal"
      >
        Street
        <input
          type="text"
          id="street"
          className="mt-2 text-sm text-[#8D8D91] bg-[#f9f9f9] rounded"
        />
      </label>
      <label
        htmlFor="landmark"
        className="mt-4 mb-1 text-[#1B2A4E] text-sm font-normal"
      >
        Landmark
        <input
          type="text"
          id="landmark"
          className="mt-2 text-sm text-[#8D8D91] bg-[#f9f9f9] rounded"
        />
      </label>
    </form>
  </>
);
